/**
 * PrevNextArticle
 */

import Config from '../Config';
import Util from '../Util';
import Template from './Template';

class PrevNextArticle {
	constructor() {
		// constructor
	}

	public setUI( $prevNode: any, isAfterAppend: boolean = true ) {
		if ( Config.prevNextData && ( Config.prevNextData.previousArticle || Config.prevNextData.nextArticle ) ) {
			const $node = jQuery( `<div class="board-prev-next-article"></div>` );

			( isAfterAppend ) ?
				$prevNode.after( $node ) :
				$prevNode.append( $node );

			const data = Config.prevNextData;
			const template = Template.prevNext( data );
			$node.append( template );
		}
	}

	public get( articleId: string, callback: any ) {
		const prevNext: any = Util.get( Config.prevNext({
			board: Config.board,
			articleId,
		}), 'GET');

		const prevNext$ = Util.from( prevNext );

		prevNext$.subscribe( ( data: any ) => {
			if ( data && data.previousArticle ) {
				if ( callback ) {
					callback( data.previousArticle.articleId );
				}
				return;
			}

			if ( callback ) {
				callback( 0 );
			}

		}, ( data: any ) => {

			if ( callback ) {
				callback( 0 );
			}

		});
	}

  // setUI( data ) {
	// 	return Template.prevNext( data );
	// }
}

export default PrevNextArticle;
